import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styles from './style.module.scss';
import { BudgetIcon, CalendarIcon, CrossIcon, DelIcon, DetailIcon, EditIcon, PencilIcon, PlusIcon, ProjectManagerIcon, ProjectNameIcon, StatusCheckIcon, TickIcon, managerAvatar } from 'assets';
import { useSelector } from 'react-redux';
import { useFetcher, useNavigate } from 'react-router-dom';
import { tableHeading, tableData, options, optionsConfigure, tabs, tabEnum } from './Constant';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomTab from 'shared/components/common/custom_tab/CustomTab';
import ManageCategory from '../manage_category/ManageCategory';
import ManageSubCategory from '../manage_sub_category/ManageSubCategory';
import AddProduct from 'shared/modal/add_product/AddProduct';
import Brand from '../brand/Brand';
import { DeleteProductMutation, GetAllProductQuery } from 'shared/services/product_service/ProductService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
import CompetibleBrand from '../competible_brand/CompetibleBrand';
import Colors from '../manage_color/Colors';
import WareHouse from '../manage_wareHoue/WareHouse';
import ShopifyLocations from '../shopify_locations/ShopifyLocations';
import ShopifyProducts from './ShopifyProducts';

// import Competible_Model from 'shared/modal/'

export default function ManageProduct() {
    const { isLoading: DelLoading, mutate: DelMutate, isSuccess } = DeleteProductMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const navigate = useNavigate();
    const [milestoneOption, setMileStoneOption] = useState(false);
    const [activeTab, setActiveTab] = useState('Brand');
    const [openProduct, setOpenProduct] = useState(false);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const toggleEditUser = () => {
        setIsEdit(!isEdit);
    };
    const closeProductHandler = () => setOpenProduct(false);
    const closeDelConfirmation = () => setOpenDelConfirm(false);
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const obj = {};
    if (clicksearch) {
        obj['search'] = clicksearch;
    }
    const allTaskQueryParams = new URLSearchParams(obj).toString();
    const { isLoading, data, isError, error } = GetAllProductQuery(allTaskQueryParams);


    const SearchBars = () => {
        if (searchMenu.length > 0) {
            const filteredData = data.filter((user) => user.name.toLowerCase().includes(searchMenu.toLowerCase()));
            setSearchResults(filteredData);
        }
    };
    const [editModelData, setEditModelData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleEditModel = (model) => {
        setEditModelData(model);
        setIsEditMode(true);
        setOpenProduct(true);
    };

    const handleCloseModelModal = () => {
        setOpenProduct(false);
        setEditModelData(null);
        setIsEditMode(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Model
                    </div>
                ),
                accessor: 'model',
                Cell: ({ row }) => <div className="w-100">{row.original.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100 text-center`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Competible Brand
                    </div>
                ),
                accessor: 'compatiableBrand',
                Cell: ({ row }) => <div className="w-100 text-center">{row.original?.compatiableBrand?.name}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100 text-end me-2`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-end align-items-center">
                        <div className="mx-2">
                            <EditIcon
                                className="pointer"
                                onClick={() => {
                                    handleEditModel(row.original);
                                }}
                            />
                        </div>
                        <div className="mx-2">
                            <DelIcon
                                className="pointer"
                                onClick={() => {
                                    if (isRestrictActions(screenEnum.product, screenActionEnum.delete)) {
                                        setOpenDelConfirm(true);
                                        setSelectedItem(row.original);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            }
        ],

        [theme, milestoneOption]
    );
    useEffect(() => {
        if (isSuccess) {
            setSelectedItem(null);
            closeDelConfirmation();
        }
        if (data) {
            setSearchResults(data);
        }
    }, [isSuccess, data, searchMenu]);
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <CustomTab activeTab={activeTab} tabs={tabs} handleActiveTab={(tab) => setActiveTab(tab)} />
                </div>
            </div>
            {tabEnum.Brand === activeTab ? (
                <Brand />
            ) : tabEnum.Competible_Brand === activeTab ? (
                <CompetibleBrand />
            ) : tabEnum.Category === activeTab ? (
                <ManageCategory />
            ) : tabEnum.SubCategory === activeTab ? (
                <ManageSubCategory />
            ) : tabEnum.WareHouse === activeTab ? (
                <WareHouse />
            ) : tabEnum.Shopify_Locations === activeTab ? (
                <ShopifyLocations />
            ) : tabEnum.Color === activeTab ? (
                <Colors />
            ) : tabEnum.Shopify_Products === activeTab ? (
                <ShopifyProducts />
            ) : (
                tabEnum.Competible_Model === activeTab && (
                    <div className={classNames(styles.UserContainer, 'text-start')}>
                        <SearchBar
                            searchKey="name"
                            suggestionsSource={data}
                            onSearchChange={setSearchResults} // ✅ REQUIRED!
                        />

                        <div className={styles.Header}>
                            <Heading heading={'Manage Model'} headingStyle={styles.Heading} />
                            <div className="d-flex">
                                <CustomButton
                                    Icon={PlusIcon}
                                    IconStyle={classNames('me 1', styles.IconStyle)}
                                    text={'Model'}
                                    submitHandle={() => {
                                        if (isRestrictActions(screenEnum.product, screenActionEnum.create)) {
                                            setEditModelData(null);
                                            setIsEditMode(false);
                                            setOpenProduct(true);
                                        }
                                    }}
                                    containerStyle={classNames(styles.AddProduct)}
                                />
                            </div>
                        </div>

                        <GenericTable columns={columns} data={searchResults || []} TDTextStyle={classNames(styles.TDTextStyle)} TableWrapperStyle={classNames(styles.Table)} />
                        <AddProduct
                            show={openProduct}
                            isEdit={isEditMode}
                            editData={editModelData}
                            handleClose={handleCloseModelModal}
                        />
                        <DeleteConfirmation
                            show={openDelConfirm}
                            loading={DelLoading}
                            ConfimationHeading="Delete Product"
                            Desc={'Are you sure you want to delete the Product ?'}
                            DeleteHandler={() => {
                                DelMutate(selectedItem?._id);
                            }}
                            handleClose={closeDelConfirmation}
                        />
                        {isLoading && <OverlayLoading />}
                    </div>
                )
            )}
        </DashboardWrapper>
    );
}